export default __webpack_public_path__ + "static/media/pic-4.5d4ceef5.png";